var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "357.766 141.819 486.079 310.721",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m361.77,398.11h19.92c11.63,0,18.67,6.9,18.67,16.85v.14c0,11.28-8.78,17.13-19.71,17.13h-8.15v14.63h-10.73v-48.75Zm19.22,24.59c5.36,0,8.5-3.2,8.5-7.38v-.14c0-4.81-3.34-7.38-8.71-7.38h-8.29v14.9h8.5Z",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m412.11,398.11h22.29c6.2,0,11,1.74,14.21,4.95,2.72,2.72,4.18,6.55,4.18,11.14v.14c0,7.87-4.25,12.82-10.45,15.11l11.91,17.41h-12.54l-10.45-15.6h-8.43v15.6h-10.73v-48.75Zm21.59,23.68c5.22,0,8.22-2.79,8.22-6.9v-.14c0-4.6-3.2-6.96-8.43-6.96h-10.66v14h10.87Z",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m464.13,422.63v-.14c0-13.86,10.93-25.21,25.98-25.21s25.84,11.21,25.84,25.07v.14c0,13.86-10.93,25.21-25.98,25.21s-25.84-11.21-25.84-25.07Zm40.61,0v-.14c0-8.36-6.13-15.32-14.77-15.32s-14.63,6.83-14.63,15.18v.14c0,8.36,6.13,15.32,14.77,15.32s14.63-6.83,14.63-15.18Z",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m529.3,398.11h19.02c15.32,0,25.91,10.52,25.91,24.24v.14c0,13.72-10.59,24.38-25.91,24.38h-19.02v-48.75Zm19.02,39.07c8.78,0,14.7-5.92,14.7-14.56v-.14c0-8.64-5.92-14.7-14.7-14.7h-8.29v29.39h8.29Z",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m585.43,422.63v-.14c0-13.86,10.93-25.21,25.98-25.21s25.84,11.21,25.84,25.07v.14c0,13.86-10.93,25.21-25.98,25.21s-25.84-11.21-25.84-25.07Zm40.61,0v-.14c0-8.36-6.13-15.32-14.77-15.32s-14.63,6.83-14.63,15.18v.14c0,8.36,6.13,15.32,14.77,15.32s14.63-6.83,14.63-15.18Z",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m650.6,398.11h22.29c6.2,0,11,1.74,14.21,4.95,2.72,2.72,4.18,6.55,4.18,11.14v.14c0,7.87-4.25,12.82-10.45,15.11l11.91,17.41h-12.54l-10.45-15.6h-8.43v15.6h-10.73v-48.75Zm21.59,23.68c5.22,0,8.22-2.79,8.22-6.9v-.14c0-4.6-3.2-6.96-8.43-6.96h-10.66v14h10.87Z",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m705.27,398.11h10.73v48.75h-10.73v-48.75Z",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m732,398.11h9.89l22.85,30.02v-30.02h10.59v48.75h-9.12l-23.61-30.99v30.99h-10.59v-48.75Z",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m807.56,397.76h9.89l20.9,49.1h-11.21l-4.46-10.93h-20.62l-4.46,10.93h-10.93l20.9-49.1Zm11.28,28.7l-6.48-15.81-6.48,15.81h12.95Z",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 369.87,
    cy: 357.74,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 386.31,
    cy: 341.31,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 419.18,
    cy: 341.31,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.05,
    cy: 341.31,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 484.92,
    cy: 341.31,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 517.79,
    cy: 341.31,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 550.66,
    cy: 341.31,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 583.54,
    cy: 341.31,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 616.41,
    cy: 341.31,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 649.28,
    cy: 341.31,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 682.15,
    cy: 341.31,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 715.02,
    cy: 341.31,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 747.89,
    cy: 341.31,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 780.76,
    cy: 341.31,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.63,
    cy: 341.31,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 419.18,
    cy: 341.31,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 419.18,
    cy: 308.44,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.05,
    cy: 308.44,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.05,
    cy: 275.56,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 484.92,
    cy: 308.44,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 517.79,
    cy: 308.44,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 550.66,
    cy: 308.44,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 583.54,
    cy: 308.44,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 616.41,
    cy: 308.44,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 649.28,
    cy: 308.44,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 682.15,
    cy: 308.44,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 715.02,
    cy: 308.44,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 747.89,
    cy: 308.44,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 484.92,
    cy: 275.56,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 484.92,
    cy: 242.69,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 517.79,
    cy: 275.56,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 550.66,
    cy: 275.56,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 583.54,
    cy: 275.56,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 616.41,
    cy: 275.56,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 649.28,
    cy: 275.56,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 682.15,
    cy: 275.56,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 715.02,
    cy: 275.56,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 517.79,
    cy: 242.69,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 517.79,
    cy: 209.82,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 583.54,
    cy: 209.82,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 616.41,
    cy: 209.82,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 616.41,
    cy: 176.95,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 632.84,
    cy: 160.52,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 649.28,
    cy: 176.95,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 649.28,
    cy: 209.82,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 682.15,
    cy: 209.82,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 550.66,
    cy: 242.69,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 583.54,
    cy: 242.69,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 616.41,
    cy: 242.69,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 649.28,
    cy: 242.69,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 682.15,
    cy: 242.69,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 715.02,
    cy: 242.69,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 747.89,
    cy: 275.56,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 780.76,
    cy: 308.44,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 402.74,
    cy: 357.74,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 402.74,
    cy: 324.87,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 435.62,
    cy: 324.87,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 435.62,
    cy: 292,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 468.49,
    cy: 292,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 468.49,
    cy: 259.13,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.36,
    cy: 292,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 534.23,
    cy: 292,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 567.1,
    cy: 292,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 599.97,
    cy: 292,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 632.84,
    cy: 292,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 665.71,
    cy: 292,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 698.58,
    cy: 292,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 731.45,
    cy: 292,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.36,
    cy: 259.13,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.36,
    cy: 226.26,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 534.23,
    cy: 259.13,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 567.1,
    cy: 259.13,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 599.97,
    cy: 259.13,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 632.84,
    cy: 259.13,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 665.71,
    cy: 259.13,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 698.58,
    cy: 259.13,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 534.23,
    cy: 226.26,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 567.1,
    cy: 226.26,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 599.97,
    cy: 226.26,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 599.97,
    cy: 193.39,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 632.84,
    cy: 193.39,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 665.71,
    cy: 193.39,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 632.84,
    cy: 226.26,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 665.71,
    cy: 226.26,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 698.58,
    cy: 226.26,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 731.45,
    cy: 259.13,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 764.33,
    cy: 292,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 468.49,
    cy: 324.87,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.36,
    cy: 324.87,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 534.23,
    cy: 324.87,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 567.1,
    cy: 324.87,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 599.97,
    cy: 324.87,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 632.84,
    cy: 324.87,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 665.71,
    cy: 324.87,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 698.58,
    cy: 324.87,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 731.45,
    cy: 324.87,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 764.33,
    cy: 324.87,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 797.2,
    cy: 324.87,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 435.62,
    cy: 357.74,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 468.49,
    cy: 357.74,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.36,
    cy: 357.74,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 534.23,
    cy: 357.74,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 567.1,
    cy: 357.74,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 599.97,
    cy: 357.74,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 632.84,
    cy: 357.74,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 665.71,
    cy: 357.74,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 698.58,
    cy: 357.74,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 731.45,
    cy: 357.74,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 764.33,
    cy: 357.74,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 797.2,
    cy: 357.74,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 830.07,
    cy: 357.74,
    r: 8.22,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogoWhite);
export default __webpack_public_path__ + "static/media/Full-logo-white.31b9dbb144ae63d98f88fdf89ef33abc.svg";
export { ForwardRef as ReactComponent };